import React from "react";
import { Route, Redirect } from "react-router-dom";
const ProtectedRoute = ({ children, ...rest }) => {
    localStorage.setItem("careXactSOSAdmin_LastURL",window.location);

    return (
        <Route
            {...rest}
            render={({ location }) =>
                localStorage.getItem("careXactSOSAdmin_BearerToken") ? (children)
                    : (
                        <Redirect
                            to={{
                                pathname: "/auth/login-page",
                                state: { from: location }
                            }}
                        />
                    )
            }
        />
    );
};
export default ProtectedRoute;